<template>
  <v-container>
    <h1>Document Processor Stats</h1>
    <v-row>
      
      <v-col v-for="stats in docStats" :key="`${stats.title}`" cols="12" md="4">
        <SalesGraph :sale="stats" />        
      </v-col>

    </v-row>
    <v-row>
      <v-col v-for="statistic in statistics" :key="`${statistic.title}`" cols="12" md="4">
        <StatisticCard :statistic="statistic"/>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="8">
            <v-data-table
                :headers="headers"
                :items="docErrors"
                :items-per-page="5"
                class="elevation-1"
                @click:row="selectRow"
                :multi-sort="true"
            ></v-data-table>
        </v-col>
        <v-col cols="4">
            <v-card >
                <v-card-title>Total Errors</v-card-title>
                <v-card-text class="display-2">{{numErrors}}</v-card-text>
            </v-card>
        </v-col>
        
  
    </v-row>
    
  </v-container>
</template>

<script>
import docStats from '../data/doc_stats.json'
import docErrors from '../data/doc_data.json'
import SalesGraph from '../components/SalesGraph'
import StatisticCard from '../components/StatisticCard'

export default {
    components: {
        SalesGraph,
        StatisticCard,
    },
    data() {
        var stats=[
            
            ];
        docStats.forEach(element => {
            stats.push({value:element.sales.reduce((a,b)=>a+b,0),title:element.title});
        });
        return {
           docStats: docStats,
           docErrors: [
             {id:'fra007.pdf',invoice_number:'',supplier:'Unknown',total_amount:'704.5'},
             {id:'fra065.pdf',invoice_number:'2019/0015004',supplier:'Unknown',total_amount:''},
             {id:'fra103.pdf',invoice_number:'',supplier:'VIAJES ALCÓN SA',total_amount:'102.3'},
             {id:'fra204.pdf',invoice_number:'F19/ZZ001443',supplier:'Unknown',total_amount:''},
             {id:'fra415.pdf',invoice_number:'',supplier:'Unknown',total_amount:'813'},
             {id:'fra417.pdf',invoice_number:'F19/ZZ001443',supplier:'Unknown',total_amount:''},
             {id:'fra707.pdf',invoice_number:'',supplier:'EL CORTE INGLÉS',total_amount:'315'},
           ],  
           numErrors: 7,  
           statistics:stats,
           headers: [  { text: 'File', value: 'id'},
                    { text: 'Invoice Number', value: 'invoice_number'},
                    { text: 'Supplier', value: 'supplier'},
                    { text: 'Total amount', value: 'total_amount'},           
            ],
        }
    },
    methods: {
        selectRow(data) {
            //let routeData = this.$router.resolve({name: 'document-detail', params: { document: data.id }});
            //window.open(routeData.href, '_blank');
        },
    },
}
</script>

<style>

</style>